import React, { useState } from 'react'
import { Box, Button, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MessageOutlinedIcon from 'components/material-symbol/icons/Message'
import PersonAddOutlinedIcon from 'components/material-symbol/icons/PersonAdd'
import CoachAddStudentModal from 'components/add-student-modal/coach-add-student-modal'
import StreamSendMessageButton from 'components/stream-messaging/send-message-button'
import SensitiveInfoWrapper from 'lib/auth/SensitiveInfoWrapper'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { amplitudeEvent } from 'lib/amplitude'

const useStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    margin: 0,
  },
  actionGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap',
      gap: 0,
    },
  },
  button: {
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      minWidth: '75px',
      maxWidth: '75px',
      height: '72px',
      fontSize: '0.75rem',
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  stickyActionGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
  },
  stickyIconButton: {
    minWidth: 40,
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: '50px',
    border: '1px solid #E0E0E0',
    backgroundColor: '#FFFFFF',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      borderColor: '#E0E0E0',
      boxShadow: 'none',
    },
  },
}))

export default function LeadActionButtons({
  contact = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    externalId: '',
  },
  leadId,
  useStickyIcons = false,
}) {
  const { firstName, lastName, phoneNumber, email, externalId } = contact
  const classes = useStyles()
  const history = useHistory()

  const [
    isConvertLeadToStudentModalOpen,
    setIsConvertLeadToStudentModalOpen,
  ] = useState(false)

  const convertLeadToStudentButton = () => {
    amplitudeEvent('convert-to-student-clicked', {
      leadId,
      url: window.location.href,
      path: window.location.pathname,
    })
    setIsConvertLeadToStudentModalOpen(true)
  }

  if (useStickyIcons) {
    return (
      <>
        <Box className={classes.stickyActionGroup}>
          <SensitiveInfoWrapper>
            <StreamSendMessageButton
              userIds={[externalId]}
              component={props => (
                <IconButton
                  {...props}
                  className={classes.stickyIconButton}
                  aria-label="Message"
                >
                  <MessageOutlinedIcon fontSize="small" />
                </IconButton>
              )}
            />
          </SensitiveInfoWrapper>
          <IconButton
            className={classes.stickyIconButton}
            aria-label="Convert to student"
            onClick={convertLeadToStudentButton}
          >
            <PersonAddOutlinedIcon fontSize="small" />
          </IconButton>
        </Box>
        <CoachAddStudentModal
          open={isConvertLeadToStudentModalOpen}
          setOpen={setIsConvertLeadToStudentModalOpen}
          onAdd={() => history.push('/pga-coach/leads')}
          initialValues={{
            studentFirstName: firstName,
            studentLastName: lastName,
            email,
            phoneNumber,
          }}
          leadId={leadId}
        />
      </>
    )
  }

  return (
    <>
      <Box className={classes.actions}>
        <Box className={classes.actionGroup}>
          <SensitiveInfoWrapper>
            <StreamSendMessageButton
              userIds={[externalId]}
              variant="outlined"
              color="primary"
              className={classes.button}
              startIcon={<MessageOutlinedIcon fontSize="small" />}
            >
              Message
            </StreamSendMessageButton>
          </SensitiveInfoWrapper>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            startIcon={<PersonAddOutlinedIcon fontSize="small" />}
            onClick={convertLeadToStudentButton}
          >
            Convert
          </Button>
        </Box>
      </Box>
      <CoachAddStudentModal
        open={isConvertLeadToStudentModalOpen}
        setOpen={setIsConvertLeadToStudentModalOpen}
        onAdd={() => history.push('/pga-coach/leads')}
        initialValues={{
          studentFirstName: firstName,
          studentLastName: lastName,
          email,
          phoneNumber,
        }}
        leadId={leadId}
      />
    </>
  )
}

LeadActionButtons.propTypes = {
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    externalId: PropTypes.string,
  }),
  leadId: PropTypes.string,
  useStickyIcons: PropTypes.bool,
}
